import type { TimeControl } from 'api/time-control/config/types';
import { millisecondsToDeciseconds } from 'src/utils/number/milliseconds-to-deciseconds';
import { getTimestamp } from 'chessboard/model/move/get-timestamp';

/**
 * Transform an array of raw time (game time remaining) values
 * to timestamp (move time taken) values
 */
export function convertTimesToTimestamps(
  timeControl: TimeControl.Model | null,
  timestamps: (number | undefined)[],
): (number | null | undefined)[] {
  if (timestamps && timeControl) {
    const baseTimeDs = millisecondsToDeciseconds(timeControl.baseTime);
    const incrementDs = millisecondsToDeciseconds(timeControl.increment);

    return timestamps.map((timestamp, index) => {
      if (typeof timestamp !== 'number') {
        return timestamp;
      }

      return getTimestamp({
        baseTimeDs,
        incrementDs,
        lastTimeDs: index <= 1 ? undefined : timestamps[index - 2],
        currentTimeDs: timestamp,
      });
    });
  }

  return timestamps;
}
